<h2 mat-dialog-title>Lerneinheit {{ data?.id ? "bearbeiten" : "anlegen" }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab label="Basisdaten">
            <mat-dialog-content [formGroup]="form" class="grid">

                <mat-form-field class="full-width">
                    <mat-label>Titel</mat-label>
                    <input matInput formControlName="title" />
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Untertitel</mat-label>
                    <input matInput formControlName="subtitle" />
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Beschreibung</mat-label>
                    <input matInput type="text" required placeholder="" formControlName="description" />
                </mat-form-field>

                <div class="preview-container border-area full-width">
                    <div class="content">
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openImageChoice()">
                                <mat-icon>add_photo_alternate</mat-icon>
                                Vorschaubild auswählen
                            </button>
                        </div>

                        @if (getImageName() && getImageName().length > 0) {
                            <div>
                                <div class="media-container">
                                    <div class="media-item">
                                        <div class="media-item">
                                            <img src="{{ imageUrl() }}" alt="" class="preview" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-1">
                                <span class="info cut-long-text">{{ getImageName() }}</span>
                            </div>

                            <div>
                                <button mat-icon-button (click)="deleteMediaEntry()">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        }
                    </div>
                </div>

                <mat-form-field>
                    <mat-label>Anwendung</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                            <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="filter-item">
                    <pixl-state-cb [required]="true" [initValue]="form.get('status')?.value" (onStateChange)="statusChanged($event)" />
                </div>

                <mat-form-field>
                    <mat-label>Unterrichtsphase</mat-label>
                    <input matInput formControlName="lesson_section" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Bearbeitungszeit</mat-label>
                    <input
                            matInput
                            type="number"
                            formControlName="processing_time"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Lerneinheits-Typ</mat-label>
                    <input matInput formControlName="learning_unit_type" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Lerneinheits-Ziel</mat-label>
                    <mat-select formControlName="learning_unit_goal">
                        <mat-option value="voluntarily"
                        >Freiwillig</mat-option
                        >
                        <mat-option value="mandatory"
                        >Verpflichtend</mat-option
                        >
                    </mat-select>
                </mat-form-field>

                <div class="full-width">
                    <pixl-multi-combo-entity-search
                            [label]="moduleLabel"
                            [observable$]="modules$"
                            [namingColumn]="'title'"
                            [externalSearch]="true"
                            (onStateChange)="receiveModuleData($event)"
                            (onSearchChange)="receiveModuleQuery($event)"
                            (scrolledToEnd)="loadMoreModules($event)"
                            [(selectedValues)]="selectedModules"
                    >
                    </pixl-multi-combo-entity-search>
                </div>

                <div class="border-area full-width">
                    <div class="multi-select mt-2">
                        <pixl-multi-combo-entity-search
                            [label]="learningSectionLabel"
                            [observable$]="learningSections$"
                            [namingColumn]="'name'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningSectionData($event)"
                            (onSearchChange)="receiveLearningSectionQuery($event)"
                            (scrolledToEnd)="loadMoreLearningSections($event)"
                            [(selectedValues)]="selectedLearningSections"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>
                    <div class="mb-1">Anordnen (Drag'n Drop)</div>
                    <div cdkDropList class="order-list" (cdkDropListDropped)="reOrderSelectedLearningSections($event)">
                        <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
                        <div *ngFor="let learningSection of selectedLearningSections; trackBy: trackLearningSectionsById" class="order-box" cdkDrag>
                            {{ learningSection.title }}
                        </div>
                    </div>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || 'Metadaten'">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata [parentForm]="form" [objectType]="'learning_unit'"></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
        @if (isAbuConsumer) {
            <mat-tab label="Kanton & Beruf">
                <mat-dialog-content class="grid">
                    <div class="full-width">
                        <p>Zuordnung von Modulen zu Kanton und Beruf</p>

                        @for (row of metadataRows; track $index) {
                            <div class="border-area full-width metadata-row">
                                <div class="metadata-row-fields">
                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowCantonLabel($index)"
                                            [observable$]="metadataRowCantonOptions$[$index]"
                                            [namingColumn]="'label'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowCantonData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowCantonQuery($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedCantons[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowProfessionLabel($index)"
                                            [observable$]="metadataRowProfessionOptions$[$index]"
                                            [namingColumn]="'label'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowProfessionData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowProfessionQuery($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedProfessions[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <div class="multi-select">
                                        <pixl-multi-combo-entity-search
                                            [label]="getMetadataRowModuleLabel($index)"
                                            [observable$]="metadataRowModules$[$index]"
                                            [namingColumn]="'title'"
                                            [externalSearch]="true"
                                            (onStateChange)="receiveMetadataRowModuleData($index, $event)"
                                            (onSearchChange)="receiveMetadataRowModuleQuery($index, $event)"
                                            (scrolledToEnd)="loadMoreMetadataRowModules($index, $event)"
                                            [(selectedValues)]="metadataRowSelectedModules[$index]"
                                        >
                                        </pixl-multi-combo-entity-search>
                                    </div>

                                    <button mat-icon-button color="warn" (click)="removeMetadataRow($index)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                @if (metadataRowSelectedModules[$index] && metadataRowSelectedModules[$index].length) {
                                    <div class="metadata-row-order">
                                        <div class="metadata-order-label">Anordnen (Drag'n Drop)</div>
                                        <div cdkDropList class="order-list" (cdkDropListDropped)="reOrderMetadataRowModules($index, $event)">
                                            <!-- eslint-disable-next-line @angular-eslint/template/prefer-control-flow -->
                                            <div *ngFor="let module of metadataRowSelectedModules[$index]; trackBy: trackById" class="order-box" cdkDrag>
                                                {{ module.title }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                        <div class="add-button-wrapper mb-3">
                            <button mat-raised-button color="primary" type="button" (click)="addMetadataRow()">
                                <mat-icon>add</mat-icon>
                                Kanton & Beruf hinzufügen
                            </button>
                        </div>
                    </div>
                </mat-dialog-content>
            </mat-tab>
        }
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Speichern</button>
    </mat-dialog-actions>
</div>
